<template>
  <v-container fluid>
    <v-layout class="mb-5" align-start justify-left wrap>
      <v-flex>
        <create-quick-transaction @created="onTransactionCreated"></create-quick-transaction>
      </v-flex>
    </v-layout>
    <transactions-table
    :transactions="transactions"
    @saved="onTransactionSaved"
    @canceled="onTransactionCanceled"
    ></transactions-table>
  </v-container>
</template>
<style lang="scss" scoped>
  .small-note {
    font-size: 10px;
    color: gray;
  }
  .just-edited {
    color: #1e7b00;
  }
</style>

<script>
import { DataState } from "@/state";
import TransactionsTable from "@/components/TransactionsTable";
import CreateQuickTransaction from "@/components/CreateQuickTransaction";

export default {
  components: {
    TransactionsTable,
    CreateQuickTransaction
  },
  data() {
    return {
      transactions: [],
      state: DataState.newLoading()
    };
  },
  mounted() {
    this.onLoaded();
  },

  methods: {
    onLoaded() {
    },
    onTransactionCreated(transaction) {
      this.transactions.unshift(transaction);
    },

    onTransactionSaved(transaction, gonext) {
    },

    onTransactionCanceled(transaction, gonext) {
    }
  }
};
</script>
